const defaultState = {};

export default function loading(state = defaultState, action) {
  switch (action.type) {
    case 'INIT_FETCHING':
      return {
        ...state,
        [action.key]: { ...state[action.key], loading: true, error: undefined }
      };

    case 'INIT_FETCH_SUCCESS':
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          data: action.data,
          loading: false,
          error: undefined
        }
      };

    case 'INIT_FETCH_ERROR':
      return {
        ...state,
        [action.key]: { ...state[action.key], loading: false, error: action.error }
      };
    default:
      return state;
  }
}
